<!-- 顶部 -->
<template>
  <header :class="{ header: true, 'header-active': isShowBgColor }">
    <div class="topbar">
      <div class="left">
        <router-link to="/">
          <img
            :src="require('@/assets/full_logo.png')"
            alt="logo"
            class="logo theme"
          />
          <img
            src="@/assets/full_logo_white.png"
            alt="logo"
            class="logo white"
          />
        </router-link>
        <div class="line"></div>
        <div class="slogan">匠心咨询 成就匠心建筑</div>
      </div>
      <div class="right">
        <i class="el-icon-phone-outline"></i>
        <span>咨询热线：{{ globalConfig.linkPhone }}</span>
      </div>
    </div>
    <div class="nav-box">
      <div class="navs">
        <div
          :class="{ nav: true, active: formatMainNavActive(item) }"
          v-for="item in navList"
          :key="item.path"
        >
          <div
            class="title"
            v-if="item.subs && item.subs.length != 0"
            @click="navToChild(item)"
          >
            {{ item.name }}
          </div>
          <router-link
            :to="item.path"
            class="title"
            @click.native="routerLink"
            v-else
            >{{ item.name }}</router-link
          >
          <div class="subs">
            <router-link
              :class="{ sub: true, 'sub-active': sub.path == $route.path }"
              :to="sub.path"
              v-for="sub in item.subs"
              :key="sub.path"
              @click.native="routerLink"
            >
              {{ sub.name }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="navbar">
      <div class="left">
        <img
          src="../../assets/icon_menu.png"
          alt=""
          class="icon"
          @click="openSide"
        />
      </div>
      <div class="center">{{ globalConfig.name }}</div>
      <div class="right"></div>
    </div>
    <div class="placeholder"></div>
    <div class="sidebar" v-show="mBarShow">
      <div class="mask" @click="closeBar"></div>
      <div class="inbar">
        <div
          :class="{ bar: true, activeBar: $route.path == item.path }"
          v-for="item in navList"
          :key="item.path"
        >
          <div class="first" @click="navTo(item)">
            <div class="name">{{ item.name }}</div>
            <i class="el-icon-arrow-right" v-show="item.subs.length != 0"></i>
          </div>
          <div class="subs" v-show="item.expand">
            <div
              :class="{ sub: true, active: child.path == $route.path }"
              v-for="child in item.subs"
              :key="child.path"
              @click="subNavTo(child)"
            >
              {{ child.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
export default {
  data() {
    return {
      isShowBgColor: false, // 是否展示底色
      mBarShow: false,
    };
  },
  computed: {
    ...mapState(Store, ["globalConfig"]),
  },
  props: {
    navList: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.isShowBgColor = document.documentElement.scrollTop > 72;
    window.addEventListener("scroll", this.pageScroll);
  },
  mounted() {},
  methods: {
    // 主导航条激活格式处理
    formatMainNavActive(item) {
      if (item.path == "/") {
        // 首页 在首页时才激活
        return this.$route.path == "/";
      } else {
        // 其他页 匹配时激活
        const firstPath = this.$route.path.split("/")[1];
        return "/" + firstPath == item.path;
      }
    },
    // 监听页面滚动
    pageScroll() {
      const top = document.documentElement.scrollTop;
      this.isShowBgColor = top > 72;
    },
    routerLink() {
      window.scrollTo({ top: 0 });
    },
    navToChild(item) {
      window.scrollTo({ top: 0 });
      this.$router.push(item.subs[0].path);
    },
    openSide() {
      this.mBarShow = true;
    },
    closeBar() {
      this.mBarShow = false;
    },
    // 移动端跳转
    navTo(item) {
      if (item.subs.length != 0) {
        item.expand = !item.expand;
      } else {
        this.$router.push(item.path);
        this.mBarShow = false;
        window.scrollTo({ top: 0 });
      }
    },
    subNavTo(item) {
      this.$router.push(item.path);
      this.mBarShow = false;
      window.scrollTo({ top: 0 });
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.pageScroll);
  },
};
</script>

<style lang="scss" scoped>
@keyframes moveIn {
  from {
    opacity: 0;
    transform: translateX(-220px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes rotateFadeIn {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.header {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 999;

  &:hover {
    background-color: #fff;

    .topbar {
      .left {
        .theme {
          display: block;
        }
        .white {
          display: none;
        }
        .slogan {
          color: #5e5d5d;
        }
      }
      .right {
        color: #5e5d5d;
      }
    }
    .nav-box .navs {
      .nav {
        color: #5e5d5d;
      }
      .active {
        color: $theme;
      }
    }
  }

  --main-width: 1200px;

  .topbar {
    width: var(--main-width);
    margin: 0 auto;
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;

    .left {
      height: 33px;
      display: flex;
      align-items: center;

      .logo {
        width: auto;
        height: 33px;
      }
      .theme {
        display: none;
      }
      .line {
        width: 1px;
        height: 37px;
        background: #ffffff;
        opacity: 0.2;
        margin: 0 10px;
      }
      .slogan {
        letter-spacing: 1px;
        color: #fff;
      }
    }
    .right {
      font-size: 18px;
      display: flex;
      align-items: center;
      color: #fff;

      span {
        margin-left: 5px;
      }
      .icon {
        width: 18px;
      }
    }
  }
  .nav-box {
    color: #fff;

    .navs {
      display: flex;
      justify-content: center;

      .nav {
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;

        &:hover {
          color: $theme;

          .title {
            font-weight: bold;
          }
          .subs {
            display: block;
          }
        }

        .title {
          padding: 5px 15px;
        }

        .subs {
          display: none;
          width: 100%;
          font-size: 15px;
          background-color: $theme;
          color: #fff;
          text-align: center;
          position: absolute;
          left: 0;
          top: 100%;
          box-shadow: 1px 3px 5px #333;
          animation: fadeIn 0.2s;

          .sub {
            padding: 10px 0;
            display: block;

            &:hover {
              background-color: #fff;
              color: $theme;
            }
          }
          .sub-active {
            background-color: #fff;
            color: $theme;
          }
        }
      }
      .active {
        font-weight: bold;
        font-size: 20px;
      }
    }
  }
}
.header-active {
  background-color: #fff;

  .topbar {
    .left {
      .theme {
        display: block;
      }
      .white {
        display: none;
      }
      .slogan {
        color: #5e5d5d;
      }
    }
    .right {
      color: #5e5d5d;
    }
  }

  .nav-box .navs {
    .nav {
      color: #5e5d5d;
    }
    .active {
      color: $theme;
    }
  }
}
@media (max-width: 750px) {
  .topbar {
    display: none;
  }
  .header {
    --main-width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;

    .banner {
      height: 100%;
      border-bottom: 1px solid #e8e8e8;

      .in {
        padding: 0 15px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo {
          height: 30px;
          margin: 10px 0;
          display: block;
        }
        .icons,
        .nav-box {
          display: block;
        }
      }
    }
    .nav-box {
      width: 100vw;
      height: 100vh;
      position: absolute;
      left: 0;
      top: 100%;
      z-index: 999;
      background-color: rgba($color: #000000, $alpha: 0.5);
      border-bottom: 0;
      display: none;

      .navs {
        width: 100%;
        background-color: #fff;
        flex-direction: column;

        .nav {
          border: 0;
          padding: 0;

          &:first-child {
            border-left: 0;
          }
          &:hover {
            background-color: #fff;
          }
          .title {
            color: #333;
            font-size: 15px;
            line-height: 40px;
            padding: 0 15px;
          }
        }
      }
    }
  }
}
.navbar {
  display: none;
  width: 100%;
  height: 44px;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  align-items: center;
  color: #333;
  box-shadow: 0 0 5px #3d3d3d;

  .left,
  .right {
    width: 20px;
    height: 100%;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: 20px;
  }
  .center {
    text-align: center;
    flex-grow: 1;
    @include ellipsis;
  }
}
.placeholder {
  display: none;
  height: 44px;
}
.sidebar {
  display: none;
}

@media (max-width: 750px) {
  .header {
    position: unset;

    .topbar,
    .nav-box {
      display: none;
    }
    .navbar {
      display: flex;
    }
    .placeholder {
      display: block;
    }
  }
  .sidebar {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1098;
    display: block;

    .mask {
      width: 100%;
      height: 100%;
      z-index: 2;
      background-color: rgba($color: #000000, $alpha: 0.5);
      position: absolute;
      left: 0;
      top: 0;
    }

    .inbar {
      width: 220px;
      height: 100vh;
      background-color: #fff;
      box-shadow: 3px 0px 4px 0px rgba(21, 21, 21, 0.1);
      position: relative;
      z-index: 3;
      animation: moveIn 0.2s linear;
      overflow: auto;
    }

    .bar {
      border-bottom: 1px solid #f4f4f4;

      .first {
        padding: 15px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .type {
        width: 19px;
        margin-right: 20px;
      }
      .name {
        font-size: 14px;
      }
      .subs {
        background-color: #ededed;

        .sub {
          padding: 15px;
          box-sizing: border-box;
          font-size: 14px;
        }
        .active {
          background-color: $theme;
          color: #fff;
          font-weight: bold;
        }
      }
    }
    .activeBar {
      background-color: $theme;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
